export const userConstants = {
  REGISTER_REQUEST: "USERS_REGISTER_REQUEST",
  REGISTER_SUCCESS: "USERS_REGISTER_SUCCESS",
  REGISTER_FAILURE: "USERS_REGISTER_FAILURE",

  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
  SOCIAL_LOGIN_ERROR: "SOCIAL_LOGIN_ERROR",
  CANCEL_SOCIAL_LOGIN_FAILURE: "CANCEL_SOCIAL_LOGIN_FAILURE",
  SOCIAL_EMAIL_ALREADY_EXISTS: "SOCIAL_EMAIL_ALREADY_EXISTS",
  ACTIVATE_DEVICE_FLOW: "ACTIVATE_DEVICE_FLOW",
  DATA_SUCCESS: "USERS_DATA_SUCCESS",
  DATA_FAILURE: "USERS_DATA_FAILURE",
  LOGOUT: "USERS_LOGOUT",
  SHOW_ACTIAVTION_POPUP: "SHOW_ACTIAVTION_POPUP",
  SHOW_EDIT_PROFILE_POPUP: "SHOW_EDIT_PROFILE_POPUP",
  SHOW_CHANGE_PASSWORD_POPUP: "SHOW_CHANGE_PASSWORD_POPUP",
  UPDATE_USER: "UPDATE_USER",
  SHOW_GIVEFEEDBACK_POPUP: "SHOW_GIVEFEEDBACK_POPUP",
  SHOW_MY_NOTIFICATIONS_POPUP: "SHOW_MY_NOTIFICATIONS_POPUP",
  SHOW_FEATURE_TOGGLE:"SHOW_FEATURE_TOGGLE",
  SHOW_USER_DETAILS_ADMIN:"SHOW_USER_DETAILS_ADMIN",
  CREATE_NEW_USER_ADMIN:"CREATE_NEW_USER_ADMIN",
  SUCCESS_TOAST: "SUCCESS_TOAST",
  SUCCESS_TOAST_MESSAGE: "SUCCESS_TOAST_MESSAGE",
  CREATE_NEW_CERTIFICATE: "CREATE_NEW_CERTIFICATE",
  SHOW_CERTIFICATE_POPUP: "SHOW_CERTIFICATE_POPUP",
  IS_USER_ORG_ADMIN: "IS_USER_ORG_ADMIN",
  IS_USER_UNAUTHORISED: "IS_USER_UNAUTHORISED",
  SOP_ACCESS_SET: "SOP_ACCESS_SET",
  SET_ORG_USER_LIST: "SET_ORG_USER_LIST",
  SHOW_DATA_EXPORT_POPUP: "SHOW_DATA_EXPORT_POPUP",
};

export const USER_TYPE_CONSTANT = {
  ADMINISTRATOR: {
    NAME: "Administrator",
    ROLE_ID: "66dd3a48-5185-11e3-9430-fbcf1b1a2e9a"
  },
  STANDARD_USER: {
    NAME: "Standard User",
    ROLE_ID: "B5C42396-BC53-11E2-9678-15B654818C3B"
  },
  INDIVIDUAL_USER: {
    NAME: "Individual User",
    ROLE_ID: "B5C423C8-BC53-11E2-9678-15B654818C3B"
  }
};

export const TIME_CONSTANT = {
  ONE_MINUTE: 60000,
  ONE_SECOND: 10000
}